import * as React from "react";
import type { SVGProps } from "react";
const SvgUploadPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={39}
    fill="none"
    viewBox="0 0 50 39" {...props}
  >
    <path
      fill="url(#upload-pdf_svg__a)"
      d="m2.033 25.352-1.73 2.869a1.78 1.78 0 0 0 .82 2.547l16.881 7.14a3.06 3.06 0 0 0 3.217-.515l2.884-2.521 3.269 1.145a3.92 3.92 0 0 0 3.768-.708c2.935-2.431 8.947-7.757 12.805-13.469 3.525-5.222 5.101-8.593 5.794-10.381s-.129-1.724-.975-1.968L34.731 5.297z"
      opacity={0.6}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="1.11 1.11"
      strokeMiterlimit={10}
      strokeWidth={0.311}
      d="M9.955 25.832c-1.141-.438-1.397-1.943-.462-2.727 2.461-2.072 6.627-5.892 10.28-10.755 3.717-4.953 6.242-8.876 7.524-10.973a2.54 2.54 0 0 1 2.871-1.12L46.883 5.07c1.23.36 1.87 1.724 1.345 2.894-1.307 2.933-3.947 8.324-7.729 13.765-3.448 4.966-7.075 8.117-9.344 9.803s-3.076 1.235-4.627.643z"
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="1.11 1.11"
      strokeMiterlimit={10}
      strokeWidth={0.311}
      d="M39.846 11.17c-1.41 2.88-4.23 8.194-8.191 13.494-2.243 2.997-4.512 5.3-6.486 6.998a41 41 0 0 1-3.191 2.483 4.82 4.82 0 0 1-4.64.476L.982 27.713a1.2 1.2 0 0 1-.282-.155c-.871-.591-.961-1.904-.09-2.585 2.538-1.994 6.82-5.66 10.64-10.408.012-.025.038-.051.05-.064.167-.193.32-.399.475-.592 3.589-4.515 6.075-8.091 7.37-10.047a2.54 2.54 0 0 1 2.91-1.016l3.576 1.158 7.331 2.393 5.627 1.826a2.123 2.123 0 0 1 1.244 2.946z"
    />
    <path
      fill="#00D9CA"
      d="M28.938 12.9c-.487-.887-1.73-.81-2.577-.63-.897.206-1.704.67-2.384 1.274-1.333 1.184-2.012 2.856-2.281 4.58a7.97 7.97 0 0 1-4.102-.875 8 8 0 0 1-1.166-.746c-.141-.116-.295-.219-.423-.347a9 9 0 0 1-1.859-2.187 8 8 0 0 1-.756-1.685l-.475.591c.065.167.129.335.206.49a9.4 9.4 0 0 0 2.307 3.138 9 9 0 0 0 1.025.785 8.53 8.53 0 0 0 4.96 1.466h.206c0 .052-.013.116-.013.167-.18 1.917 0 3.898.513 5.75.423 1.57 1.115 3.075 2.102 4.362.14.193.294.373.448.553.295.347.616.656.962.965.128.116.32.128.448 0 .116-.116.128-.348 0-.45-.205-.18-.41-.374-.602-.566-1-1.043-1.769-2.29-2.294-3.641-.641-1.647-.949-3.396-1-5.159-.013-.669 0-1.35.077-2.02a9.3 9.3 0 0 0 4.191-1.543 8.9 8.9 0 0 0 1.948-1.788c.513-.656 1.013-1.673.564-2.496zm-.628 1.377c-.32.747-.962 1.364-1.564 1.866a8.64 8.64 0 0 1-4.41 1.916c.18-1.029.513-2.02 1.077-2.894.885-1.364 2.448-2.47 4.128-2.367.346.026.743.142.871.489.116.309.026.694-.102.99"
      opacity={0.3}
    />
    <defs>
      <linearGradient
        id="upload-pdf_svg__a"
        x1={0.046}
        x2={49.83}
        y1={21.737}
        y2={21.737}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#258AE9" />
        <stop offset={0.2} stopColor="#228FE6" />
        <stop offset={0.5} stopColor="#1AA0E0" />
        <stop offset={0.7} stopColor="#0DBBD6" />
        <stop offset={1} stopColor="#00DACB" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgUploadPdf;
